export default __webpack_public_path__ + "static/media/heart.d78dd800.svg";